import { AJAX_WP_Query } from 'ajax-wp-query';
import './components/index';
import './pages/index';

jQuery(document).ready(function ($) {
	$(window).load(function () {
		setTimeout(function () {
			if (document.querySelector('#hs-form-iframe-0')) {
				let inputAddress = document
					.querySelector('#hs-form-iframe-0')
					.contentDocument.querySelector('.hbspt-form form input[name="address_australia"]');

				if (inputAddress) {
					const options = {
						componentRestrictions: { country: 'au' }
					};

					new google.maps.places.Autocomplete(inputAddress, options);

					let hsFormHead = $('#hs-form-iframe-0').contents().find('head');
					let customCSS = `
						<style>
								.pac-container{
									background-color: #ffffff;
									top: 1165px !important;
								}
	
								@media(max-width: 880px){
									.pac-container{
										top: 1200px !important;
									}
								}
	
								@media(max-width: 655px){
									.pac-container{
										top: 1255px !important;
									}
								}
	
								@media(max-width: 480px){
									.pac-container{
										top: 1655px !important;
									}
								}
	
								@media(max-width: 425px){
									.pac-container{
										top: 1625px !important;
									}
								}
	
								@media(max-width: 350px){
									.pac-container{
										top: 1625px !important;
									}
								}
	
								.pac-icon{
									display: none;
								}
	
								.pac-item{
									cursor: pointer;
									padding: 10px;
									border: 1px solid rgba(0, 0, 0, 0.1);
								}
		
								.pac-matched{
									font-weight: bold;
								}
						</style>
					`;

					hsFormHead.append(customCSS);
				}
			}
		}, 1);
	});
});
